import { useState } from "react";
import { useEffect } from "react";
import { api } from "../../services/axios";
import { DownloadsDiv } from "./styles";
import Excel from '../../assets/img/excel.png'

export default function Downloads() {
  const url = "core/ajax/report"
  const [files, setFiles] = useState([]);

  useEffect(() => {
    api.post(url, {
      type: 'getFiles',
      authx: ''
    })
      .then(function (res) {
        console.log('AQUI OH: ',res.data);
        setFiles(res.data)
      })
      .catch(function (error) {
        console.log(error);
      });
  }, [])

  return (
    <DownloadsDiv>
      <h1>Historico</h1>
      <ul>
        {files.length > 0 ? files.map((e) => {
          return <li className="card">
            <img src={Excel} alt="Excel" />
            <a href={e.url}>
              {e.name}
            </a>
          </li>
        }) : <li style={{ padding: '1rem', color: '#888' }}>Nenhum arquivo disponível. Os relatórios são gerados sob demanda na tela de Reports.</li>}
      </ul>
    </DownloadsDiv>
  );
}
